/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_AbortInputs */



/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Dialogue_List_Export_Precheck_AbortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_abort = /** @type {((inputs?: Dialogue_List_Export_Precheck_AbortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_AbortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abbrechen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aborto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abortar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アボート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीच में बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abortar")
	return /** @type {LocalizedString} */ ("Abort")
});